module.exports = __webpack_public_path__ + "img/user-desktop-bg.54a5a4f5.svg";